<template>
  <!-- Navbar for small screens -->
  <v-app-bar v-if="display.smAndDown" elevation="0" title="" color="#111111">
    <v-btn density="comfortable" icon="custom:TheLeegIcon" @click="gotoLobby"/>
    <v-btn density="compact" color="white" rounded="tile" @click="gotoHome">{{ currentSubdomain() }}</v-btn>
    <v-spacer></v-spacer>

    <v-menu v-if="notPickup">
      <template v-slot:activator="{ props }">
        <v-btn color="white" v-bind="props" append-icon="mdi-menu-down">Schedule</v-btn>
      </template>
      <v-list>
        <v-list-item v-for="league in leagues"
          :title="league.name"
          @click="gotoLeagueSchedule(league.id)"
        ></v-list-item>
      </v-list>
    </v-menu>
    <v-app-bar-nav-icon variant="text" color="#ffffff" @click.stop="toggleNavDrawer"></v-app-bar-nav-icon>
    <v-btn color="white" rounded="tile" title="Log in" icon @click="gotoLogin"><v-icon icon="mdi-account" size="large" /></v-btn>
  </v-app-bar>

  <!-- Navbar for medium screens (and larger) -->
  <v-app-bar v-else elevation="0" title="" color="#111111">
    <v-btn density="comfortable" icon="custom:TheLeegIcon" @click="gotoLobby"/>
    <v-btn density="compact" color="white" rounded="tile" @click="gotoHome">{{ currentSubdomain() }}</v-btn>

    <v-spacer></v-spacer>

<!--
    <v-btn color="white" rounded="tile" @click="gotoSchedule">Schedule</v-btn>
    <v-menu v-if="currentSubdomain() == 'test'">
-->
    <v-menu v-if="notPickup">
      <template v-slot:activator="{ props }">
        <v-btn color="white" v-bind="props" append-icon="mdi-menu-down">Schedule</v-btn>
      </template>
      <v-list>
        <v-list-item v-for="league in leagues"
          :title="league.name"
          @click="gotoLeagueSchedule(league.id)"
        ></v-list-item>
      </v-list>
    </v-menu>

    <v-btn v-if="showRules" color="white" rounded="tile" @click="gotoRules">League Rules</v-btn>
    <v-btn v-if="notPickup" color="white" rounded="tile" @click="gotoFreeAgents">Free Agents</v-btn>

    <v-menu :location="location" :close-on-content-click="false">
      <template v-slot:activator="{ props }">
        <v-btn color="white" v-bind="props" append-icon="mdi-menu-down">Teams</v-btn>
      </template>

      <v-list>
        <!-- Loop through leagues using standard v-list-item triggers -->
        <v-list-item v-for="league in leagues" :key="league.id || league.name" link>
          <v-list-item-title>{{ league.name }}</v-list-item-title>

          <!-- Arrow indicator showing a submenu exists -->
          <template v-slot:append>
            <v-icon icon="mdi-menu-right" size="small"></v-icon>
          </template>

          <!-- Nested submenu replacing v-list-group -->
          <v-menu
            activator="parent"
            submenu
            open-on-hover
            location="end top"
            :open-on-focus="false"
          >
            <v-list>
              <v-list-item
                v-for="team in league.teams"
                :key="team.id || team.nickname"
                :title="team.name"
                :disabled="team.show_website !== true"
                @click="gotoTeamPage(league.nickname, team.nickname)"
              >
                <!-- Uncommented and fixed string syntax for your logo layout -->
                <template v-slot:prepend>
                  <v-img
                    v-if="team.pictures && team.pictures.includes('Team Logo')"
                    height="30px"
                    width="30px"
                    :src="teamLogoURL(team.id)"
                    class="mr-2"
                  ></v-img>
                </template>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item>
      </v-list>
    </v-menu>
<!--
    <v-menu :location="location">
      <template v-slot:activator="{ props }">
        <v-btn color="white" v-bind="props" append-icon="mdi-menu-down">Teams</v-btn>
      </template>
      <v-list>
        <v-list-group v-for="league in leagues">
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
              :title="league.name"
            ></v-list-item>
          </template>

          <v-list-item
            v-for="team in league.teams"
            :title="team.name"
            :disabled="team.show_website != true"
            @click="gotoTeamPage(league.nickname, team.nickname)"
          >
            <template v-slot:prepend>
              <v-img v-if="team.pictures.includes('Team Logo')" height="30px" width="30px":src="teamLogoURL(team.id)" class="mr-2"></v-img>
            </template>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-menu>
-->

    <!-- CJS - because loggedIn knowledge is irratic in tenant, the decision has been made to only show login icon at all times -->
    <!--
    <v-app-bar-nav-icon v-if="loggedIn" variant="text" color="#ffffff" @click.stop="toggleNavDrawer"></v-app-bar-nav-icon>
    <v-btn v-if="!loggedIn" color="white" rounded="tile" title="Log in" icon @click="gotoLogin">
      <v-icon icon="mdi-account" size="large" />
    </v-btn>
    -->
    <v-btn color="white" rounded="tile" title="Log in" icon @click="gotoLogin"><v-icon icon="mdi-account" size="large" /></v-btn>
  </v-app-bar>

  <!-- Drawer for all navbar items on small screens -->
  <v-navigation-drawer v-model="showNavDrawer" location="end" temporary color="grey-darken-4">
    <!-- CJS - because loggedIn knowledge is irratic in tenant, the decision has been made to only show login icon at all times -->
    <!--
    <li v-if="!loggedIn && display.smAndDown" class="d-flex justify-end">
    -->
      <!-- This isn't working all the time, so I'm commenting out for now
      <v-btn v-if="loggedIn" rounded="tile" color="grey-darken-4" text-color="white" @click="logout">Log out</v-btn>
      <v-btn v-else-if="display.smAndDown" rounded="tile" color="grey-darken-4" text-color="white" @click="gotoLogin">Log in</v-btn>
      -->
      <!--- Replacement code for above commented out code -->
    <!--

      <v-btn rounded="tile" color="grey-darken-4" text-color="white" @click="gotoLogin">Log in</v-btn>
    </li>

    <li v-if="loggedIn" class="d-flex justify-end">
      <v-btn rounded="tile" color="grey-darken-4" text-color="white" @click="gotoProfile">My Profile</v-btn>
    </li>
    -->
    <li v-if="display.smAndDown && showRules" class="d-flex justify-end">
      <v-btn rounded="tile" color="grey-darken-4" text-color="white" @click="gotoRules">League Rules</v-btn>
    </li>

    <li v-if="display.smAndDown" class="d-flex justify-end">
      <v-btn rounded="tile" color="grey-darken-4" text-color="white" @click="gotoFreeAgents">Free Agents</v-btn>
    </li>

    <li v-if="display.smAndDown" class="d-flex justify-end">
      <v-list>
      <v-list-group value="Teams">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" rounded="tile" color="grey-darken-4" text-color="white" append-icon="mdi-menu-down">Teams</v-btn>
        </template>
        <v-list-group v-for="league in leagues">
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
              :title="league.name"
            ></v-list-item>
          </template>

          <v-list-item
            v-for="team in league.teams"
            :title="team.name"
            :disabled="team.show_website != true"
            @click="gotoTeamPage(league.nickname, team.nickname)"
          >
            <template v-slot:prepend>
              <v-img v-if="team.pictures.includes('Team Logo')" height="30px" width="30px":src="teamLogoURL(team.id)" class="mr-2"></v-img>
            </template>
          </v-list-item>
        </v-list-group>
      </v-list-group>
      </v-list>
    </li>

    <!--
    <li class="d-flex justify-end">
      <v-btn rounded="tile" color="grey-darken-4" text-color="white" @click="gotoCoaches">Coach Game Reports</v-btn>
    </li>
    -->
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { onMounted, computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useDisplay } from 'vuetify'
import { rootUrl } from '@/utils/helpers/urlHelpers'
import { subdomainUrl } from '@/utils/helpers/urlHelpers'
import { currentSubdomain } from '@/utils/helpers/urlHelpers'
import { useAuthStore } from '@/stores/auth.store'
import { loginUrl, logoutUrl } from '@/utils/helpers/urlHelpers'
import { useAccountStore } from '@/stores/account.store'
const accountStore = useAccountStore()

import { useLeagueStore } from '@/stores/league.store'
const leagueStore = useLeagueStore()

import { showSnackbarInternalError } from '@/utils/showSnackbar'
import { Cloudinary } from '@cloudinary/url-gen'

const leagueGroup = ref([])
const leagueListItem = ref([])
const leagueExpand = (index) => {
  leagues.value.forEach((league, i) => {
    if (i == index) {
      leagueGroup.value[i].value = true
    } else {
      leagueGroup.value[i].value = false
    }
  })
}

const router = useRouter()

const authStore = useAuthStore()

const notPickup = computed(() => { return (currentSubdomain() != 'pickup') })
const showRules = computed(() => {
  if (currentSubdomain() == 'misl') { return true }
  else if (currentSubdomain() == 'boulder') { return true }
  else return false
  //return accountStore.showRules 
})
//const loggedIn = computed(() => authStore.isAuthenticated)
//const loggedIn = ref(authStore.isAuthenticated)
//const loggedIn = ref()
const gotoLogin = () => (location.href = loginUrl())
//const logout = () => (location.href = logoutUrl()) // This is necessary to logout from non-subdomain, rather than calling: { authStore.logout() }
const gotoHome = () => (location.href = subdomainUrl(currentSubdomain()))
const gotoLobby = () => location.href = rootUrl()
const gotoRules = () => router.push({ name: 'rules' })
//const gotoSchedule = () => router.push({ name: 'schedule' })
const gotoSchedule = () => {
  router.push({
    name: 'schedule',
    params: { id: -1 }
  })
}
const gotoLeagueSchedule = (league_id) => {
  console.log("League ID:", league_id)
  router.push({
    name: 'schedule',
    params: { id: league_id }
  })
}

// CJS - If we ever have an account as the root domain (e.g. boldersoccer.com), this will need to change if it uses TenantNavbar
const gotoFreeAgents = () => (location.href = rootUrl() + 'free-agents/' + currentSubdomain())

const gotoProfile = () => (location.href = rootUrl() + 'profile') // { router.push({ name: 'profile' }) }

const gotoTeamPage = (league_nickname, team_nickname)  => (location.href = subdomainUrl(currentSubdomain()) + league_nickname + "/" + team_nickname)


const showNavDrawer = ref(false)
const showSubNavDrawer = ref(false)
const showAccountDrawer = ref(false)
const display = ref(useDisplay())

const toggleNavDrawer = () => {
  showNavDrawer.value = !showNavDrawer.value
}
const toggleSubNavDrawer = () => {
  showAccountDrawer.value = false
  showSubNavDrawer.value = !showSubNavDrawer.value
}

const toggleAccountDrawer = () => {
  showSubNavDrawer.value = false
  showAccountDrawer.value = !showAccountDrawer.value
}

const account_id = ref()
const leagues = ref([])
const getLeagues = () => {
  accountStore
    .fetchBySubdomain(currentSubdomain())
    .then((response) => {
      account_id.value = response.data.id
    })
    .finally(() => {
      leagueStore.fetchAll(account_id.value, false)
        .then((response) => {
          response.data.forEach((league) => {
            leagues.value.push(league)
          })
        })
        .catch((error) => {
          showSnackbarInternalError(`Something went wrong when loading the leagues: ${error}`)
        })
    })
    .catch((error) => {
      showSnackbarInternalError(`Something went wrong when loading the account: ${error}`)
    })
}

// Create a Cloudinary instance and set your cloud name.
const cld = new Cloudinary({
  cloud: {
    cloudName: 'hk31qci0h',
  },
})

const teamLogoURL = (team_id) => {
  const myImg = cld.image('Teams/' + String(team_id) + '/' + 'Team Logo' + '.jpg')
  return myImg.toURL()
}

onMounted(() => {
  getLeagues()

  //loggedIn.value = authStore.isAuthenticated
  //console.log("loggedIn.value:", loggedIn.value)
  //console.log("currentUser:", authStore.currentUser)
  //console.log("loggedIn.value:", authStore.isAuthenticated)
})

</script>
